import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
export const BreadCrumbItem = ({ crumbNumber, isActive, label, handleClick }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    return (_jsxs(Stack, Object.assign({ flexDirection: "row", sx: {
            display: "flex",
            flexFlow: isDesktop ? "row" : "column",
            alignItems: "center",
        } }, { children: [_jsx(Avatar, Object.assign({ sx: {
                    marginRight: theme.spacing(0.5),
                    width: theme.spacing(3),
                    height: theme.spacing(3),
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                    fontSize: "1em",
                    opacity: isActive ? 1 : 0.4,
                } }, { children: crumbNumber })), _jsx(Typography, Object.assign({ variant: "h4", sx: {
                    opacity: isActive ? 1 : 0.4,
                }, onClick: handleClick }, { children: label }))] })));
};
